import is from 'helpers/is';

export const GTM_KEY = is().prod ? 'GTM-K8KC3L' : 'GTM-TKR2HDT';

export const COOKIE_BODY_CLASS = '_has-cookie';

export const POLICY_URL = `https://siteplus.${
  is().prod ? 'com' : 'wtf'
}/legal/privacy`;

export const COOKIE_LCZ_STRINGS = {
  toolbar_text:
    'We use cookies to enable essential functionality on our websites, offer you a better browsing experience, analyze website traffic, and personalize content. By clicking Accept you consent to our use of cookies.',
  'toolbar_read-about-cookies-link': 'Read about how we use cookies.',
  'toolbar_cookie-settings-btn': 'Cookie settings',
  'toolbar_accept-btn': 'Accept',
  'toolbar_reject-btn': 'Reject',
  popup_heading: 'Your Cookie Settings',
  popup_description:
    'Siteplus uses cookies to enable essential functionality on our websites, offer you a better browsing experience, analyze website traffic, and personalize content.',
  'popup_checkbox-on-status-text': 'On',
  'popup_checkbox-off-status-text': 'Off',
  'popup_read-about-cookies-link': 'Read about how we use cookies',
  'popup_privacy-policy-link': 'Privacy and Cookies Policy',
  popup_categories_heading: 'Cookie Categories',
  'popup_categories_essential-heading': 'Essential',
  'popup_categories_essential-description':
    'These cookies are strictly necessary to provide you with services available through our websites. You cannot refuse these cookies without impacting how our websites function. You can block or delete them by changing your browser settings, as described under the heading "Managing cookies" in the',
  'popup_categories_functionality-heading': 'Performance and Functionality',
  'popup_categories_functionality-description':
    'These cookies are used to enhance the performance and functionality of our websites, or to help us customize our websites and application for you in order to enhance your experience, but are non-essential to their use. However, without these cookies, certain functionality may become unavailable.',
  'popup_categories_analytic-heading': 'Analytics',
  'popup_categories_analytic-description':
    'These cookies collect information that is used in aggregate form to help us understand how our websites are being used or how effective our marketing campaigns are.',
  'popup_allow-all-btn': 'Allow all',
  'popup_save-btn': 'Save settings',
};
